import { useState } from 'react'
import { DateRangeSelector } from '@kenect-ut/kenect-ui-kit'
import Dropdown from '../../../../components/dropdown/Dropdown'

import './DateRangeDropdown.scss'
import { useNavigationContext } from '../../Navigation.context'
import DropdownActions from '../DropdownActions'

function DateRangeDropdown() {
  const { selectedDateRange, setSelectedDateRange } = useNavigationContext()
  const [workingRange, setWorkingRange] = useState()

  const handleSave = () => setSelectedDateRange(workingRange)
  const handleChange = (value) => setWorkingRange(value)

  return (
    <Dropdown title="Date Range" value={selectedDateRange?.label}>
      <DateRangeSelector
        initialRange={selectedDateRange}
        onChange={handleChange}
        className="navDateRangePicker"
      />
      <DropdownActions save={handleSave} />
    </Dropdown>
  )
}

export default DateRangeDropdown
